export const handleErrorCodesPostMessage = (errorCode) => {
  window.parent.postMessage(
    { name: 'errorReceived', payload: { errorCode, errorMessage: '' } },
    '*'
  );
};
